import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  FormControl,
  FormLabel,
  Modal,
  Row,
} from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";
import CabinCard from "../../components/CabinCard";
import {
  AccommodationChangeRequest,
  AccommodationDetailsBasic,
  AccommodationImage,
  sendAccommodationChangeRequestAsync,
} from "./accommodationSlice";
import { getAccommodationTranslationItem } from "../../common/misc";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { addStatusToast } from "../../components/StatusToast";
import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import InputErrorsDisplay from "../../features/errors/InputErrorsDisplay";

const AccommodationModal = ({
  accommodationDetailsBasic,
  accommodationImages,
  renderCabinCard,
  isOwnAccommodation,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
  accommodationImages: AccommodationImage[];
  renderCabinCard: Function;
  isOwnAccommodation: boolean;
}) => {
  const [submitted, setSubmitted] = useState(false);
  const inputErrors = useAppSelector(selectInputErrors);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSubmitted(false);
    setTextareaValue("");
    setPerustiedotChecked(false);
    setVarusteluChecked(false);
    setLisapalvelutChecked(false);
    setKuviaChecked(false);
    setKuvausChecked(false);
    setKuvausChecked(false);
    setMuutAsiatChecked(false);
  };
  const handleShow = () => setShow(true);

  const [checkedPerustiedot, setPerustiedotChecked] = useState(false);
  const [checkedVarustelu, setVarusteluChecked] = useState(false);
  const [checkedLisapalvelut, setLisapalvelutChecked] = useState(false);
  const [checkedKuvia, setKuviaChecked] = useState(false);
  const [checkedKuvaus, setKuvausChecked] = useState(false);
  const [checkedMuutAsiat, setMuutAsiatChecked] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const dispatch = useAppDispatch();

  const handlePerustiedotCheckboxChange = () => {
    setPerustiedotChecked(!checkedPerustiedot);
  };

  const handleVarusteluCheckboxChange = () => {
    setVarusteluChecked(!checkedVarustelu);
  };

  const handleLisapalvelutCheckboxChange = () => {
    setLisapalvelutChecked(!checkedLisapalvelut);
  };

  const handleKuviaCheckboxChange = () => {
    setKuviaChecked(!checkedKuvia);
  };

  const handleKuvausCheckboxChange = () => {
    setKuvausChecked(!checkedKuvaus);
  };

  const handleMuutAsiatCheckboxChange = () => {
    setMuutAsiatChecked(!checkedMuutAsiat);
  };

  const handleTextareaChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setTextareaValue(e.target.value);
  };
  const handleSendChangeRequest = () => {
    let cabinName = getAccommodationTranslationItem(
      "fi_FI",
      "AccommodationName",
      accommodationDetailsBasic,
    );
    let accommodationChangeRequest: AccommodationChangeRequest = new (class
      implements AccommodationChangeRequest
    {
      accommodationId: string;
      accommodationName: string;
      accommodationNumber: string;
      message: string;
      perusTiedot: boolean;
      varustelu: boolean;
      lisaPalvelut: boolean;
      kuvia: boolean;
      kuvaus: boolean;
      muutAsiat: boolean;
    })();
    accommodationChangeRequest.accommodationId = accommodationDetailsBasic.id;
    accommodationChangeRequest.accommodationName = cabinName;
    accommodationChangeRequest.accommodationNumber = String(
      accommodationDetailsBasic.accommodationNumber,
    );
    accommodationChangeRequest.message = textareaValue;
    accommodationChangeRequest.perusTiedot = checkedPerustiedot;
    accommodationChangeRequest.varustelu = checkedVarustelu;
    accommodationChangeRequest.lisaPalvelut = checkedLisapalvelut;
    accommodationChangeRequest.kuvia = checkedKuvia;
    accommodationChangeRequest.kuvaus = checkedKuvaus;
    accommodationChangeRequest.muutAsiat = checkedMuutAsiat;
    setSubmitted(false);
    dispatch(
      sendAccommodationChangeRequestAsync(accommodationChangeRequest),
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          addStatusToast({
            Message: `Muutospyyntö tallennettu!`,
          }),
        );
        setSubmitted(true);
        dispatch(clearInputErrors());
      }
    });
  };

  return (
    <>
      <div className="cta bg-primary p-24 p-lg-48 text-center rounded position-relative">
        <svg
          className="position-absolute opacity-25 end-0 top-0"
          width="470"
          height="470"
          viewBox="0 0 470 470"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M409.261 244.038H390.24V225.016H409.261V244.038ZM365.714 116.802L352.268 130.248L338.822 116.802L352.268 103.356L365.714 116.802ZM351.766 234.895C351.766 299.651 299.273 352.145 234.517 352.145C169.761 352.145 117.267 299.651 117.267 234.895C117.267 170.138 169.761 117.645 234.517 117.645C299.273 117.645 351.766 170.138 351.766 234.895ZM244.037 77.5572H225.015V58.5354H244.037V77.5572ZM130.247 116.802L116.801 130.248L103.355 116.802L116.801 103.356L130.247 116.802ZM103.803 351.822L117.249 338.376L130.695 351.822L117.249 365.268L103.803 351.822ZM225.015 390.887H244.037V409.909H225.015V390.887ZM337.908 351.374L351.354 337.928L364.8 351.374L351.354 364.82L337.908 351.374ZM77.5567 244.038H58.5351V225.016H77.5567V244.038ZM421.972 176.969H373.459L408.24 142.224L400.208 68.5393L326.362 61.2963L292.066 95.6108V46.4339L234.302 0L176.968 47.0972V95.6108L142.223 60.8302L68.5389 68.862L61.296 142.708L95.6103 177.005H46.4336L0 234.769L47.097 292.103H95.6103L60.8299 326.866L68.8616 400.551L142.707 407.794L177.004 373.479V422.656L234.768 469.09L292.102 421.993V373.479L326.864 408.26L400.548 400.228L407.791 326.382L373.477 292.085H422.654L469.087 234.321L421.99 176.987L421.972 176.969Z"
            fill="white"
          />
        </svg>
        <div className="position-relative">
          <h4>Muokkaamme tiedot puolestasi</h4>
          <p>
            Onko kohteesi tiedoissa päivitettäviä tietoja?
            {/* eslint-disable-next-line no-irregular-whitespace */}
            <br />  Lähetä tiedot meille niin hoidamme asian kuntoon puolestasi.
          </p>
          <Button
            variant="outline-blue"
            disabled={!isOwnAccommodation}
            onClick={handleShow}
          >
            Lähetä muutospyyntö
          </Button>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Muutospyyntö</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderCabinCard(accommodationDetailsBasic, accommodationImages)}

          <h5>Mitä muutokset koskevat?</h5>
          <p>
            Valitse mihin tietoihin haluat muutoksia ja kirjoita vapaamuotoinen
            ohjeistus.
          </p>

          <Form>
            <div className="d-grid gap-8">
              <Form.Check
                type={"checkbox"}
                id={"1"}
                label={"Perustietoja"}
                onChange={handlePerustiedotCheckboxChange}
              />
              <Form.Check
                type={"checkbox"}
                id={"2"}
                label={"Varustelua"}
                onChange={handleVarusteluCheckboxChange}
              />
              <Form.Check
                type={"checkbox"}
                id={"3"}
                label={"Lisäpalveluja"}
                onChange={handleLisapalvelutCheckboxChange}
              />
              {/* kuvia poistettu käytöstä}
              <Form.Check
                type={"checkbox"}
                id={"4"}
                label={"Kuvia"}
                onChange={handleKuviaCheckboxChange}
              />{*/}
              <Form.Check
                type={"checkbox"}
                id={"5"}
                label={"Kuvaustekstejä"}
                onChange={handleKuvausCheckboxChange}
              />
              <Form.Check
                type={"checkbox"}
                id={"6"}
                label={"Muut asiat"}
                onChange={handleMuutAsiatCheckboxChange}
              />
              <div>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Muutospyyntö"
                  value={textareaValue}
                  onChange={handleTextareaChange}
                />
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Sulje
          </Button>
          {!submitted && (
            <Button variant="secondary" onClick={handleSendChangeRequest}>
              Lähetä
            </Button>
          )}
          {submitted && (
            <Alert variant="success">Muutospyyntö lähetetty!</Alert>
          )}
        </Modal.Footer>
      </Modal>
      <InputErrorsDisplay inputErrors={inputErrors} />
    </>
  );
};

export default AccommodationModal;
